import React, { useState } from 'react';
import Button from '../../../../ui-core/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import EmailIcon from '../../../../static/images/signup/Email.svg';
import './style.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { MODAL_TYPE } from '../../../../constants/app';
import PropTypes from 'prop-types';
import { doResetPasswordOtpRequest } from '../../../../store/action/auth';
import { setItem } from '../../../../utils/cache';

const ResetPasswordModal = ({ handleModalState }) => {
  const { isLoading } = useSelector(state => state.common);
  const dispatch = useDispatch();
  const [emailNotFound, setEmailNotFound] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        `You've entered an invalid email, please try another one.`,
      )
      .required('Please enter email.'),
  });

  const submit = async values => {
    setEmailNotFound(false);
    dispatch(
      doResetPasswordOtpRequest({
        data: values.email,
        callback: () => {
          setItem('resetDetails', JSON.stringify({ email: values.email }));
          handleModalState(MODAL_TYPE.RESET_OTP);
        },
        errorCallback: () => {
          setEmailNotFound(true);
        },
      }),
    );
  };
  const { errors, handleSubmit, setFieldValue, touched } = useFormik({
    validationSchema,
    onSubmit: submit,
    initialValues: {
      email: '',
    },
  });

  return (
    <div className="form-h">
      <h1 className="login-h2">Reset password</h1>
      <p className="login-h3 mb-3 mt-3 pb-3 sub-heading-text">
        {' '}
        Please enter your email to reset your password.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="email_input mb-80">
          <label htmlFor="email" className="text-uppercase sign_label">
            EMAIL ADDRESS
          </label>
          <div className="mt-2 email_input_text d-flex gap-0">
            <img src={EmailIcon} alt="email icon" />
            <input
              type="text"
              name="email"
              id="email"
              className="border-0 ms-2 w-100 sign_up_input"
              placeholder="Enter email"
              onChange={event => setFieldValue('email', event.target.value)}
            />
          </div>
          {!!errors?.email && !!touched?.email && (
            <span className="text-danger error-text">{errors?.email}</span>
          )}
          {emailNotFound && (
            <div className="text-danger error-text mt-4 text-center">
              We couldn’t find your email! Please check and try again.
            </div>
          )}
        </div>
        <Button
          text="SEND CODE"
          class={`OtpButton mt-4 ${isLoading && ''}`}
          isDisabled={isLoading}
          isLoading={isLoading}
          // onClick={handlePhoneOnSubmit}
        />
      </form>
    </div>
  );
};

ResetPasswordModal.propTypes = {
  handleModalState: PropTypes.func,
};

export default ResetPasswordModal;
